import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { vuetify, i18n, apolloProvider } from "./plugins";
import "./errorHandler";

Vue.config.productionTip = false;

// let _vm = null;

function createVue() {
  return new Promise(resolve => {
    const vm = new Vue({
      el: "#app",
      router,
      store,
      vuetify,
      i18n,
      apolloProvider,
      render: h => h(App)
    });
    resolve(vm);
  });
}

async function main() {
  console.log("====== 초기화 =======");
  console.log("init", Date.now());
  await store.dispatch("init");
  console.log("====== 뷰 객체 생성 =======");
  await createVue();
  console.log("vue", Date.now());
}

Array.prototype.unique = function() {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }

  return a;
};
main();
